export default __webpack_public_path__ + "static/media/flag-15.9ad8f913.gif";